import styled, { createGlobalStyle } from "styled-components";
export const StyledRightContainer = styled.div`
  header.tma__project-table-filters {
    display: flex;
    gap: 0.5rem;
    margin: 1rem auto 1rem auto;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .tma__project-table-filters--left {
      display: flex;
      gap: 0.5rem;
      flex-wrap: wrap;
      @media (max-width: 665px) {
        width: 100%;
      }
      .tma_prj_search_box,
      .tma_header_search {
        @media (max-width: 665px) {
          width: 100% !important;
        }
      }
      .tma_prj_rsrc_search_box {
        @media (max-width: 665px) {
          width: calc(50% - 0.25rem);
        }
      }
    }
    .tma__project-table-filters--right {
      display: flex;
      gap: 0.5rem;
      flex-wrap: wrap;
    }
    .tma__input_container {
      position: relative;
      top: -2px;
    }
    .tma__input_field {
      .MuiInputBase-root {
        height: 40px;
        border-radius: 5px;
      }
    }
    button.tma__dropdown__select {
      flex-basis: 20%;
      min-width: 20%;
      height: 40px;
      border: 1px solid var(--input-border-color);
      border-radius: 5px;
    }
    a.tma__add_project_link {
      text-decoration: none;
    }
    button.tma_popup_btn {
      position: relative;
      top: 0px;
      height: 40px;
    }
    button.tma_popup_btn:disabled {
      background-color: var(--input-disabled-color);
      color: grey;
      cursor: not-allowed;
    }
    button.tma__add_project {
      border-radius: 5px;
      padding: 5px 20px;
      background-color: var(--primary-text);
      height: 40px;
      display: flex;
      align-items: center;
      text-decoration: none;
      transition: all 0.3s ease-in-out;
      &:hover {
        background-color: var(--primary-text-hover);
      }
    }
    .tma_auto_complete {
      max-width: 20%;
      flex-basis: 20%;
    }
  }
  .tma_header--timesheet--approval {
    width: 100%;
    display: flex;
    padding: 1rem 0;
    align-items: center;

    @media (max-width: 750px) {
      flex-wrap: wrap;
      gap: 1rem;
    }
    h1 {
      font-size: 24px;
    }
    .week-picker-display {
      box-shadow: none;
      border: 1px solid #ddd;
      border-radius: 0;
      padding: 0;
      scale: none;
      height: 41px;
      div.selected-week-display {
        margin: 0;
        .arrow-container {
          width: 40px;
          height: 40px;
          border-radius: 0;
          background: var(--primary-text);
          svg {
            fill: #fff;
            stroke: #fff;
            width: 16px;
            height: 16px;
          }
        }
      }
      div.selected-week-indicator {
        gap: 0;
      }
    }
    .tma_timesheet_actions {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      button.tma_popup_btn:disabled {
        background-color: var(--input-disabled-color);
        color: grey;
        cursor: not-allowed;
      }
      @media (max-width: 750px) {
        margin-left: 0;
        flex-wrap: wrap;
      }
    }
  }
  div.tma__table-container {
    .ag-row {
      width: 100vw;
    }
    &.projectList {
      height: calc(100vh - 235px);
      @media (max-width: 1240px) {
        height: calc(100vh - 285px);
      }
      @media (max-width: 1084px) {
        height: calc(100vh - 235px);
      }
      @media (max-width: 980px) {
        height: calc(100vh - 285px);
      }
      @media (max-width: 665px) {
        height: calc(100vh - 335px);
      }
      @media (max-width: 384px) {
        height: calc(100vh - 345px);
      }
      .ag-header {
        font-weight: 500;
        font-size: 13px;
      }
      .ag-theme-material {
        .ag-theme-checkboxStyle-1.ag-theme-iconSet-2.ag-theme-tabStyle-3.ag-theme-inputStyle-4 {
          overflow: auto;
          border: 1px solid #ddd;
          border-radius: 3px;
          .ag-root-wrapper.ag-ltr.ag-layout-normal {
            min-width: 1250px;
            border: none;
            border-radius: 0px;
            .ag-header-cell {
              &:last-child {
                .ag-header-cell-resize {
                  &:after {
                    display: none;
                  }
                }
              }
            }
          }
        }
        .ag-center-cols-viewport {
          .ag-center-cols-container {
            width: 100% !important;
          }
          .ag-cell {
            font-size: 13px;
          }
          .ag-center-cols-container {
            .ag-row-no-focus.ag-row {
              &:nth-child(2n + 1) {
                background-color: #f5f5f5;
              }
            }
          }
        }
        .MuiTablePagination-root {
          .MuiToolbar-root {
            padding: 0 !important;
          }
        }
      }
      &.timesheet {
        height: calc(100vh - 201px);
        @media (max-width: 750px) {
          height: calc(100vh - 252px);
        }
        @media (max-width: 499px) {
          height: calc(100vh - 300px);
        }
      }
    }
  }
`;
export const StyledProjectForm = styled.form`
  padding: 1rem;
  height: calc(100vh - 60px);
  header {
    h1 {
      margin-bottom: 1rem;
    }
  }
  .tma_prj_resource,
  .tma_prj_client,
  .tma_prj_vendor,
  .tma_prj_po {
    margin-bottom: 1rem;
  }
  fieldset.tma_prj_fieldset {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: none;
    margin-top: 1rem;
    border-radius: 5px;
    border: 1px solid var(--input-border-color);
    h2.tma_section-title {
      font-size: 14px;
    }
    .tma-form_field_content {
      padding: 1rem;
      button.tma_file_upload_btn {
        height: 30px;
        border-radius: 8px;
      }
      button.tma_file_upload_btn:disabled {
        background-color: var(--input-disabled-color);
        border-color: var(--input-disabled-color) !important;
        color: grey;
        cursor: not-allowed;
      }
    }
    .tma-form_row {
      display: flex;
      align-items: center;
      margin-bottom: 0.5rem;
      justify-content: space-between;
      .MuiFormControl-root {
        height: auto;
      }
      .tma_form-control {
        flex-basis: 50%;
      }
      &.tma_multi_col {
        > .tma_form-control:first-child {
          flex-basis: 45%;
          max-width: 45%;
        }
        .tma_form-control {
          flex-basis: 25%;
          max-width: 25%;
          &.tma_min_input {
            .tma__input_container {
              justify-content: end;
            }
            label {
              display: none;
            }
            .MuiOutlinedInput-root {
              width: 215px;
            }
          }
        }
      }
      label {
        flex: 0 0 150px;
        text-align: left;
        white-space: nowrap;
        justify-content: end;
        margin-right: 0.5rem;
      }
    }
    .tma_form-control.tma_autocomplete_control {
      align-items: baseline;
      label {
        position: relative;
        top: 8px;
      }
    }
    .tma_autocomplete_control {
      .MuiPaper-root {
        width: 380px;
        ul.MuiAutocomplete-listbox {
          max-height: 25vh;
        }
      }
      ::-webkit-scrollbar {
        width: 5px;
      }
      ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px var(--input-border-color);
        border-radius: 5px;
      }

      ::-webkit-scrollbar-thumb {
        background: var(--input-border-color);
        border-radius: 5px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: var(--input-border-color);
      }
    }
    .tma_form-control,
    .tma_form-control .tma__input_container {
      display: flex;
      align-items: baseline;
      gap: 0.45rem;
    }
    .tma__input_container {
      width: 100%;
    }
    .tma_form-control {
      .tma_tooltip_btn {
        svg {
          height: 0.75em;
        }
      }
      label {
        display: flex;
        align-items: center;
      }
      .MuiOutlinedInput-root {
        &.Mui-disabled {
          background-color: var(--input-disabled-color);
          fieldset {
            border-color: var(--input-disabled-color) !important;
          }
        }
      }
      .tma__dropdown__select:disabled {
        background-color: var(--input-disabled-color);
        border-color: var(--input-disabled-color) !important;
        svg.MuiSvgIcon-root {
          display: none;
        }
      }
      .tma__dropdown__select {
        min-width: unset;
        border-radius: 0;
      }
      .MuiOutlinedInput-root,
      .tma__dropdown__select {
        height: 34px;
        width: 215px;
        border-radius: 5px;
      }
      .tma__dropdown__select,
      .tma__input_field > fieldset,
      .tma_date_container fieldset {
        border: 1px solid var(--input-border-color);
      }
      .tma__input_field fieldset,
      .tma_date_container fieldset {
        padding: 0 8px;
      }
    }
  }
  h1.tma_form_title,
  p.tma_form_secondary_title {
    margin: 0.53rem auto;
  }
  .tma_form_actions {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;
    button.tma_app_btn {
      width: 85px;
    }
  }
  p.MuiFormHelperText-root {
    margin-left: 0;
  }
  section.tma_prj_attachments {
    fieldset.tma_prj_fieldset {
      .tma-form_field_content {
        .tma-form_row {
          .tma_form-control {
            align-items: center;
          }
          .full_row {
            flex-basis: 100%;
            max-width: 100%;
          }
        }
      }
    }

    ul.tma_file_info_list {
      position: relative;
      flex-basis: 50%;
      max-width: 50%;
    }
    .tma-form_row.tma_add_new_attachment_row {
      button.tma_add_other_files {
        height: 35px;
        margin-left: 2.05rem;
        margin-top: 1rem;
      }
    }
  }
`;

export const StyledCardSection = styled.fieldset`
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  border-radius: 5px;
  .tma_section-title {
    text-transform: uppercase;
    font-size: 15px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 0.5rem;
  }
  p.tma_attachments_subtitle {
    margin: 0.5rem 0;
    color: var(--label-text);
  }
  .tma-form_field_attachments {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding-top: 0.75rem;
    flex-direction: column;
  }
  .tma-form_field_content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    &.two {
      justify-content: flex-start;
      gap: 1.5rem;
    }
    flex-wrap: wrap;
    gap: 0.75rem;
    padding-top: 0.75rem;
    @media (max-width: 767px) {
      gap: 0.5rem;
    }
    .tma_form-control {
      width: calc(33.33333% - 1rem);
      .attachments_line {
        display: flex;
        align-items: center;
        width: 592px;
        @media (max-width: 767px) {
          display: block;
          width: calc(33.33333% - 1rem);
        }
        label {
          white-space: nowrap;
          min-width: 230px;
        }
      }
      button {
        &.tma_app_btn.tma_file_upload_btn.newattachment {
          margin-top: 0.5rem;
          background-color: var(--primary-text);
        }
      }
      @media (max-width: 767px) {
        width: calc(50% - 0.5rem);
      }
      @media (max-width: 480px) {
        width: 100%;
      }
      label {
        font-size: 14px;
        padding-right: 6px;
      }
      &.control-disabled {
        .MuiOutlinedInput-root {
          background-color: #f5f5f5;
        }
      }
      input {
        font-size: 14px !important;
        min-height: 23px;
        &.MuiInputBase-input {
          border-color: #ddd;
        }
      }
      .MuiFormControl-root {
        width: 100%;
      }
      input[placeholder="DD-MM-YYYY"] {
        padding: 8.5px 12px;
      }
      .tma_auto_complete fieldset,
      fieldset {
        border-color: #ddd !important;
      }
      button {
        &.tma__dropdown__select {
          width: 100%;
          border-radius: 5px;
          border-color: #ddd;
          font-size: 14px;
          min-width: inherit;
        }
      }
      .fileUpload {
        display: flex;
        align-items: center;
        position: relative;
        justify-content: flex-end;
        min-width: 500px;
        &.uploaded-file {
          button {
            &.tma_file_upload_btn {
              width: fit-content;
              left: 0;
            }
          }
        }
        button {
          &.tma_file_upload_btn {
            position: absolute;
            width: 100%;
            height: 100%;
            padding: 0;
            z-index: 1;
            background: transparent;
            color: var(--primary-text);
            align-items: center;
            justify-content: flex-start;
            span.tma_btn_text {
              margin-left: 0;
              background-color: var(--primary-text);
              color: white;
              height: 40px;
              border-radius: 4px 0 0 4px;
              align-items: center;
              display: flex;
              padding: 0 8px;
            }
          }
        }
        ul.tma_file_info_list {
          display: block;
          width: calc(100% - 107px);
          max-width: calc(100% - 107px);
          flex-basis: calc(100% - 107px);
          border: 1px solid #ddd;
          border-radius: 0 4px 4px 0;
          padding-left: 0;
          height: 40px;

          .file_download {
            color: #0766d4 !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .file_download:hover {
            text-decoration: underline;
            cursor: pointer;
          }
          li.tma_file_item {
            a {
              text-transform: lowercase;
              text-wrap-mode: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .file_download {
              color: #0766d4;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .file_download:hover {
              text-decoration: underline;
              cursor: pointer;
            }
            display: flex;
            align-items: center;
            background-color: transparent;
            gap: 0.5rem;
            padding: 0.35rem;
            border-radius: 5px;
            justify-content: space-between;
            svg {
              display: none;
            }
            button.tma_file_remove svg {
              display: block !important;
            }
            button.tma_file_remove {
              position: relative;
              z-index: 2;
            }
          }
        }
      }
    }
  }
  .form_card {
    // border: 2px dashed #ddd;
    padding: 0rem;
    margin-top: 1rem;
    background-color: #f5f5f5;
    .tma_section-subtitle {
      color: var(--primary-text);
      font-size: 13px;
      background-color: #f5f5f5;
      padding: 0.5rem;
      border-bottom: 1px dashed #ddd;
    }
    .tma-form_field_content {
      padding: 1rem;
      &.no-padding {
        padding-bottom: 0;
      }
      input {
        background-color: white;
      }
    }
  }
`;

export const StyledStatusFilter = styled.div`
  @media (max-width: 665px) {
    width: calc(50% - 0.25rem);
  }
  button {
    width: 200px;
    min-width: auto !important;
    flex-basis: auto !important;
    @media (max-width: 665px) {
      width: 100%;
    }
  }
`;
export const ProjectFormStyles = createGlobalStyle`
   body{
       padding-bottom:5rem;
       aside.tma-app-sidebar{
        min-height:100vh !important;
      }
      section.tma_app_content{
        position:fixed;
        width: 100vw;
      }
    }
body.scrollable{
  aside.tma-app-sidebar{
  height:auto;
  overflow:auto;
  min-height:100vh !important;
   @media (min-width: 767px) {
       margin-top:3.5rem;
    }
}
header.tma__app_header{
  position:fixed;
  top:0;
  left:0;
  width:100%;
  z-index:999;
}
header.tma-page-header{
  margin-top:3.5rem;
}
}

`;
export const StyledContainer = styled.div`
  .tma_form_actions {
    .primary-outline {
      border-color: #e2040e;
      color: #e2040e;
      transition: all 0.5s ease-in-out;
      &:hover {
        background-color: #e2040e;
        color: white;
      }
    }
    .primary-success {
      background-color: var(--primary-text);
      transition: all 0.5s ease-in-out;
      &:hover {
        background-color: var(--primary-text-hover);
      }
    }
  }
`;
